export function phoneKey(number: string | null): string {
    return (number || '').replace(/\D/g, '').slice(-9);
}
